import { z } from "zod";

// 118 -- add an athlete to the decathlon competition.
export const addDecathlonAthleteSchema = z.object({
  athlete_name: z.string().trim().min(1, "Athlete name is required").max(120),
  school_id: z.string().nullable().optional(),
});

// Record one sub-event performance (points computed server-side).
export const recordDecathlonResultSchema = z.object({
  discipline: z.string().min(1),
  // 178 -- a performance is a time (s) or a distance/height (m); cap finite +
  // generously so real values pass but Infinity/NaN/absurd magnitudes reject.
  performance: z.number().finite().min(0).max(100000),
});

// Disqualify / edit an athlete.
export const updateDecathlonAthleteSchema = z.object({
  athlete_name: z.string().trim().min(1).max(120).optional(),
  school_id: z.string().nullable().optional(),
  dq: z.boolean().optional(),
  dq_reason: z.string().max(200).nullable().optional(),
});

export type AddDecathlonAthleteInput = z.infer<typeof addDecathlonAthleteSchema>;
export type RecordDecathlonResultInput = z.infer<typeof recordDecathlonResultSchema>;
export type UpdateDecathlonAthleteInput = z.infer<typeof updateDecathlonAthleteSchema>;
